import {useEffect, useState} from 'react'

/* False during SSR and the hydration render, true after mount — so client-only
 * state (localStorage, decisions) never changes the first render's output. */
export const useHydrated = () => {
    const [hydrated, setHydrated] = useState(false)
    useEffect(() => setHydrated(true), [])
    return hydrated
}
